<template>
  <confirm
    v-model="showValue"
    :title="title"
    :mask-close="maskClose"
    :has-close="hasClose"
    :can-scroll="canScroll"
    :is-double-btn="false"
    :confirm-text="btnText"
    @on-hide="$emit('on-hide')"
    @on-show="$emit('on-show')"
    @on-confirm="$emit('on-sure')"
  >
    <slot></slot>
  </confirm>
</template>

<script>
import Confirm from '../confirm'

export default {
  components: {
    Confirm,
  },
  created () {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value
    }
  },
  props: {
    value: Boolean,
    title: String,
    btnText: {
      type: String,
      default: '我知道了'
    },
    hasClose: {
      type: Boolean,
      default: true
    },
    maskClose: {
      type: Boolean,
      default: true
    },
    canScroll: {
      type: Boolean,
      default: true
    },
  },
  data () {
    return {
      showValue: false
    }
  },
  watch: {
    value (val) {
      this.showValue = val
    },
    showValue (val) {
      this.$emit('input', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?50e3c345